import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import updateLocale from 'dayjs/plugin/updateLocale';

// ---------------------------------------------------------------------------
// Konfigurasi dayjs terpusat (pengganti moment.js).
//
// Plugin yang di-extend di sini sekali saja supaya konsisten di seluruh app:
//  - utc            -> dayjs.utc(...) + .local()  (dipakai Profile.js)
//  - isSameOrBefore -> .isSameOrBefore(...)       (dipakai utils/statistik.js)
//  - updateLocale   -> .updateLocale('en', {...}) (dipakai utils/periode.js)
//
// catatan: startOf('week') / format token (D MMM Y, dddd, dll) sudah native.
// ---------------------------------------------------------------------------
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(updateLocale);

export default dayjs;
